import React from 'react';
import { CheckIcon, StarIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Pill } from './Pill';
import { heroBadges, heroImage, proof, stats } from '../data/copy';
export function Hero() {
  return <header className="w-full bg-paper" data-id="element-126" data-mp="9ll8uwe5pwmz">
      <div className="mx-auto max-w-4xl px-6 pb-10 pt-8 text-center sm:pt-12" data-id="element-127" data-mp="9igux7aw3mj4">
        <Pill tone="green" data-id="element-128" data-mp="4njpsbgqdxbi">Para docentes de Educación Física</Pill>

        <h1 className="mx-auto mt-5 max-w-3xl font-display text-[2rem] font-bold leading-[1.08] text-ink sm:text-[2.9rem] lg:text-[3.4rem]" data-id="element-129" data-mp="128fs5pz8mpyv">
          Todas tus clases de Educación Física.{' '}
          <span className="text-green" data-id="element-130" data-mp="sa9rfbp63pvl">Ya listas.</span>
        </h1>

        {/* El mockup va inmediatamente debajo de la promesa. */}
        <div className="relative mt-8" data-id="element-131" data-mp="nbydopvr4v83">
          <div className="absolute inset-x-0 bottom-8 top-10 rounded-4xl bg-mist" aria-hidden="true" data-id="element-132" data-mp="3d21rzwjzqin7" />
          <img src={heroImage} alt="El MEGAPACK Educación Física 360 completo: 6 volúmenes impresos, 5 bonos y la plataforma de recursos en tablet." className="relative mx-auto w-full max-w-sm sm:max-w-xl lg:max-w-3xl" width={1240} height={1240} decoding="sync" loading="eager" {...{
          fetchpriority: 'high'
        }} data-id="element-133" data-mp="381xkgw128y94" />
        </div>

        <p className="mx-auto mt-5 max-w-readable font-sans text-sm leading-relaxed text-muted sm:text-base" style={{
        fontSize: "12px"
      }} data-id="element-134" data-mp="399thndbur8hm">
          Un sistema 6 en 1 pensado para profes de Educación Física: 120 sesiones completas, más de 50 juegos, evaluaciones y recursos visuales. Elegís, adaptás y aplicás.
        </p>

        <div className="mt-8" data-id="element-135" data-mp="35akmq552t4kh">
          <CtaButton href="#acceso" size="large" className="w-full sm:w-auto" data-id="element-136" data-mp="2qkdai75nwhs8">
            Quiero mi MEGAPACK
          </CtaButton>
        </div>

        <ul className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2" data-id="element-137" data-mp="2vj7uhcfd8cdx">
          {heroBadges.map(badge => <li key={badge} className="flex items-center gap-1.5 font-sans text-[11px] text-muted sm:text-xs" data-id="element-138" data-mp="2hjyn92950sm3">
              <CheckIcon className="h-3.5 w-3.5 text-green" strokeWidth={2.6} aria-hidden="true" data-id="element-139" data-mp="2lmv3wnf4aene" />
              {badge}
            </li>)}
        </ul>
      </div>

      <div className="border-y border-line bg-shell" data-id="element-140" data-mp="najfrjc2u5cw">
        <dl className="mx-auto grid max-w-6xl grid-cols-2 divide-x divide-y divide-line px-6 sm:grid-cols-4 sm:divide-y-0" data-id="element-141" data-mp="ic889f9986xu">
          {stats.map(stat => <div key={stat.label} className="px-3 py-7 text-center" data-id="element-142" data-mp="degesgsyocrj">
              <dd className="font-display text-[2.5rem] font-bold leading-none text-green sm:text-[2.75rem]" data-id="element-143" data-mp="1b1fgj5yigawa">
                {stat.value}
              </dd>
              <dt className="mt-2 font-sans text-[10px] font-semibold uppercase tracking-[0.18em] text-muted sm:text-[11px]" data-id="element-144" data-mp="15zq1zgc2xf3g">
                {stat.label}
              </dt>
            </div>)}
        </dl>
      </div>

      <div className="bg-green-deep" data-id="element-145" data-mp="x3h6gcr830ml">
        <div className="mx-auto flex max-w-6xl flex-col items-center justify-center gap-4 px-6 py-5 sm:flex-row sm:gap-10" data-id="element-146" data-mp="3lt73mli5bhrm">
          <p className="font-sans text-[10px] font-semibold uppercase tracking-[0.22em] text-shell/70" data-id="element-147" data-mp="3hpsf16g55t2k">
            Ya confían en nosotros
          </p>
          <dl className="flex items-center gap-8" data-id="element-148" data-mp="21amtp33s7gj6">
            {proof.map(item => <div key={item.label} className="flex items-baseline gap-2" data-id="element-149" data-mp="218jwnz47on4y">
                <dd className="font-display text-xl font-bold text-shell" data-id="element-150" data-mp="268g468c4awp9">
                  {item.value}
                </dd>
                <dt className="font-sans text-xs text-shell/75" data-id="element-151" data-mp="2b2kbispap6qv">
                  {item.label}
                </dt>
              </div>)}
          </dl>
          <div className="flex gap-1" aria-hidden="true" data-id="element-152" data-mp="2kxuebinipi5p">
            {Array.from({
            length: 5
          }).map((_, index) => <StarIcon key={index} className="h-3.5 w-3.5 fill-gold text-gold" data-id="element-153" data-mp="2p1a5hzgtiqb0" data-mpi={index} />)}
          </div>
        </div>
      </div>
    </header>;
}